import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authSlice";
import userReducer from "./userSlice";
import categoryReducer from "./categorySlice";
import serviceReducer from "./serviceSlice";
import couponReducer from "./couponSlice";
import bookingReducer from "./bookingSlice";
import importReducer from "./importSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    category: categoryReducer,
    service: serviceReducer,
    coupon: couponReducer,
    booking: bookingReducer,
    importer: importReducer,
  },
});

export default store;
